import TaskList from "../components/TaskList";
import { ref, set, onValue, off } from "firebase/database";
import { useEffect, useState } from "react";
import TaskListOther from "../components/TaskListOther";
import { Box, Stack, Text, VStack, Button, Grid } from "@chakra-ui/react";
import { JaaSMeeting } from '@jitsi/react-sdk';

function Session({ id, uid, db, user }) {
  const [sessionData, setSessionData] = useState(null);

  useEffect(() => {
    const sessionsRef = ref(db, "sessions/" + id);
    onValue(sessionsRef, (snapshot) => {
      setSessionData(snapshot.val());
    });

    return () => {
      off(sessionsRef);
    };
  }, [db, id]);

  const handleJaaSIFrameRef = iframeRef => {
    iframeRef.style.height = '480px';
  };

  const endSession = () => {
    let end = window.confirm(
      "Are you sure you want to end this session for everyone?"
    );
    if (end) {
      set(ref(db, "sessions/" + id + "/active"), false);
    }
  };

  return !sessionData ? null : (
    <Stack
      direction={{ base: "column", lg: "row" }}
      w="full"
      justifyContent="space-evenly"
      alignItems="flex-start"
      spacing={8}
      px={4}
      my={8}
    >
      <VStack w={{ base: "full", lg: "50%" }}>
        <Text fontSize="3xl" fontWeight="bold">
          {sessionData.name}
        </Text>
        <Text>Members: {sessionData.usernames.join(", ")}</Text>
        <Button colorScheme="twitter" onClick={endSession}>
          End Session
        </Button>
        <Box w="full" py={2}>
          <JaaSMeeting
            appId="vpaas-magic-cookie-b7ccb83af4834d03baae117c39f09285"
            roomName={sessionData.name}
            configOverwrite={{
              disableThirdPartyRequests: true,
              disableLocalVideoFlip: true,
              backgroundAlpha: 0.5,
            }}
            interfaceConfigOverwrite={{
              VIDEO_LAYOUT_FIT: 'nocrop',
              MOBILE_APP_PROMO: false,
              TILE_VIEW_MAX_COLUMNS: 4
            }}
            getIFrameRef={handleJaaSIFrameRef}
          />
        </Box>
      </VStack>
      <VStack w={{ base: "full", lg: "50%" }}>
        <Grid templateColumns="repeat(2, 1fr)" gap={4}>
          <TaskList key={id} sessionId={id} user={user} uid={uid} db={db} />
          {sessionData.users.map((user, index) => {
            if (user === uid) {
              return null;
            }
            if ("tasks" in sessionData && user in sessionData.tasks) {
              return (
                <TaskListOther
                  key={sessionData.users[index]}
                  id={sessionData.users[index]}
                  name={sessionData.usernames[index]}
                  tasks={sessionData.tasks[user]}
                />
              );
            } else {
              return (
                <TaskListOther
                  key={sessionData.users[index]}
                  id={sessionData.users[index]}
                  name={sessionData.usernames[index]}
                  tasks={{}}
                />
              );
            }
          })}
        </Grid>
      </VStack>
    </Stack>
  );
}

export default Session;
